import { Link } from "react-router-dom";
import { Sparkles, Heart, Cpu, GraduationCap } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div data-testid="about-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F28C28] mb-3">
          À propos
        </div>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tighter" data-testid="about-title">
          L'histoire de Copiveo.
        </h1>

        <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground">
          <p>
            <span className="font-semibold text-foreground">Copiveo</span> est un outil pédagogique
            gratuit, imaginé et développé par un enseignant, pour les enseignants.
          </p>
          <p>
            L'idée est simple : redonner du temps aux profs. Corriger des copies, formuler
            un feedback juste, suivre les progrès, comparer des passages communs… tout
            cela peut désormais s'accompagner d'une assistance intelligente, respectueuse
            de la pédagogie et du droit des élèves.
          </p>
          <p>
            Le cœur de Copiveo est <strong className="text-foreground">gratuit et utilisable sans API</strong>. L’assistance en ligne est facultative et soumise aux quotas et conditions du fournisseur configuré. Aucun basculement payant automatique n’est prévu.
          </p>
        </div>

        <div className="mt-12 rounded-2xl bg-gradient-to-br from-[#1769E0] to-[#0F3D91] text-white p-8" data-testid="about-creator">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/70 mb-4">
            <Sparkles className="w-3.5 h-3.5" />
            Créateur
          </div>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl">
            Karim El Gartet
          </h2>
          <p className="mt-2 text-sm text-white/85">
            Professeur d'Économie Gestion · Formateur IA et Automatisation
          </p>
          <div className="mt-6 grid sm:grid-cols-3 gap-3">
            <div className="rounded-xl bg-white/10 border border-white/20 p-3">
              <GraduationCap className="w-4 h-4 text-[#F28C28] mb-2" />
              <div className="text-xs font-semibold">Enseignant</div>
              <div className="text-[10px] text-white/70">Économie Gestion</div>
            </div>
            <div className="rounded-xl bg-white/10 border border-white/20 p-3">
              <Cpu className="w-4 h-4 text-[#F28C28] mb-2" />
              <div className="text-xs font-semibold">Formateur</div>
              <div className="text-[10px] text-white/70">IA & Automatisation</div>
            </div>
            <div className="rounded-xl bg-white/10 border border-white/20 p-3">
              <Heart className="w-4 h-4 text-[#F28C28] mb-2" fill="currentColor" />
              <div className="text-xs font-semibold">Créateur</div>
              <div className="text-[10px] text-white/70">Bien commun EdTech</div>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-2xl border border-border p-6">
          <h3 className="font-heading font-semibold text-lg mb-2">Nos engagements</h3>
          <ul className="text-sm text-muted-foreground space-y-2 mt-3">
            <li>· <strong className="text-foreground">Gratuité totale</strong> — aucune monétisation directe des enseignants ou des élèves.</li>
            <li>· <strong className="text-foreground">Pédagogie avant technologie</strong> — nos suggestions sont toujours à valider par l'enseignant.</li>
            <li>· <strong className="text-foreground">Comparaison prudente</strong> — des passages communs à examiner, aucun verdict automatique de triche ou d’usage d’IA.</li>
            <li>· <strong className="text-foreground">Transmission choisie</strong> — extraction et comparaison locales ; envoi serveur ou IA explicite. Le cadre de confidentialité dépend de l’hébergement et du fournisseur activés.</li>
          </ul>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/mentions-legales"
            className="text-sm text-[#1769E0] hover:underline"
            data-testid="about-to-legal"
          >
            Consulter les mentions légales →
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
